import { toLower } from "lodash"
import pluralize from "pluralize"

export const OPPRO_EXPERIMENT_PER_PORTFOLIO_LIMIT = 5
export const RESOURCES_PER_AT_FUND = 2

export function upsellingTitle(shouldUpsell, resourceType) {
  if (!shouldUpsell) { return }
  const label = resourceType === "swap" ? "basket" : resourceType
  return `Permissions for ${toLower(pluralize(label))} are enterprise only`
}
